module.exports = __webpack_public_path__ + "static/kuchnia-photo01_thumb-aef2f31b842b5f72bb3734f0bbb15faa.jpg";